import authApiService from "./userApiService";

const handleError = (error) => {
  console.error("Permissions API Error:", error);
  return {
    success: false,
    error: error.response?.data?.error || error.message || "An error occurred",
    statusCode: error.response?.status
  };
};

const handleSuccess = (response) => ({
  success: true,
  data: response.data?.data ?? response.data,
  message: response.data?.message,
  statusCode: response.status
});

export const permissionService = {
  /**
   * Get all canonical sidebar tabs
   */
  async getAllTabs() {
    try {
      const response = await authApiService.get("/role-permissions/tabs");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Get all role permissions
   */
  async getAllRolePermissions() {
    try {
      const response = await authApiService.get("/role-permissions");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Get permissions for a specific role
   */
  async getRolePermissions(roleId) {
    try {
      const response = await authApiService.get(`/role-permissions/${roleId}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Update permissions for a specific role
   */
  async updateRolePermissions(roleId, permissions) {
    try {
      const response = await authApiService.put(`/role-permissions/${roleId}`, { permissions });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Reset role permissions to system default
   */
  async resetRolePermissions(roleId) {
    try {
      const response = await authApiService.post(`/role-permissions/${roleId}/reset`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Get effective permissions for a user
   */
  async getUserPermissions(userId) {
    try {
      const response = await authApiService.get(`/role-permissions/user/${userId}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Update custom permissions for a user profile
   */
  async updateUserPermissions(userId, permissions) {
    try {
      const response = await authApiService.put(`/role-permissions/user/${userId}`, { permissions });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  }
};

export default permissionService;
